import { PublicationSearch } from "./PublicationSearch";
import { EreaderMenuPanel } from "../bits/EreaderMenuPanel";

export const EReaderSearchPanel = ({ open }: { open: boolean }) => {
  return (
    <EreaderMenuPanel span={3} isOpen={open} fixedHeight>
      <PublicationSearch isOpen={open} />
    </EreaderMenuPanel>
  );
};
